import { render, staticRenderFns } from "./BaseCheckup.vue?vue&type=template&id=40322bd1&"
import script from "./BaseCheckup.vue?vue&type=script&lang=js&"
export * from "./BaseCheckup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports